import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-home-svg-icon',
    templateUrl: 'duotone-home-svg-icon.component.html',
    standalone: false
})

export class DuotoneHomeSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
